export var AnnouncementSubjects;
(function (AnnouncementSubjects) {
    AnnouncementSubjects["LearnMore"] = "announcement-link";
})(AnnouncementSubjects || (AnnouncementSubjects = {}));
//# sourceMappingURL=announcement.enum.js.map